import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AdCampaignsPage } from './pages/AdCampaignsPage';
import { AutomationsPage } from './pages/AutomationsPage';
import { CustomAutomationsPage } from './pages/CustomAutomationsPage';
import { WebDesignSeoPage } from './pages/WebDesignSeoPage';
import { PricingPage } from './pages/PricingPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { RobotsTxt } from './pages/RobotsTxt';
import { SitemapXml } from './pages/SitemapXml';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import { GbpSetupPage } from './pages/GbpSetupPage';
import { GmailSignatureGeneratorPage } from './pages/tools/GmailSignatureGeneratorPage';
import { CrmBusinessToolsPage } from './pages/CrmBusinessToolsPage';
import { ReputationManagementPage } from './pages/ReputationManagementPage';
function SiteLayout() {
  return <div className="flex flex-col min-h-screen bg-viridia-black font-sans text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <noscript data-id="element-2">
        <div style={{
        padding: '2rem',
        maxWidth: '800px',
        margin: '0 auto'
      }} data-id="element-3">
          <h1 data-id="element-4">
            Viridia Analytics — Phoenix Marketing Agency for Local Service
            Businesses
          </h1>
          <p data-id="element-5">
            Phoenix's premier growth partner for local service businesses.
            Expert CRM automations, ad campaigns on Google, Meta &amp; Yelp, and
            web design that turns clicks into booked jobs.
          </p>
          <h2 data-id="element-6">Our Services</h2>
          <ul data-id="element-7">
            <li data-id="element-8">
              <a href="/ai-lead-conversion" data-id="element-9">
                AI Lead Conversion — Follow-Up, AI Receptionist, Lead Nurturing
              </a>
            </li>
            <li data-id="element-10">
              <a href="/custom-automations" data-id="element-11">
                Custom Automations — Tailored Workflows, API Integrations
              </a>
            </li>
            <li data-id="element-12">
              <a href="/crm-business-tools" data-id="element-13">
                CRM &amp; Business Tools — Centralized Hub, Invoicing, Pipeline
              </a>
            </li>
            <li data-id="element-14">
              <a href="/reputation-management" data-id="element-15">
                Reputation Management — Automated Reviews, Trust Building
              </a>
            </li>
            <li data-id="element-16">
              <a href="/ad-campaigns" data-id="element-17">
                Ad Campaign Management — Google Ads, Meta Ads, Yelp Ads
              </a>
            </li>
            <li data-id="element-18">
              <a href="/web-design-seo" data-id="element-19">Web Design &amp; Local SEO</a>
            </li>
          </ul>
          <h2 data-id="element-20">Contact Us</h2>
          <p data-id="element-21">
            Phone: <a href="tel:6233000708" data-id="element-22">(623) 300-0708</a>
          </p>
          <p data-id="element-23">
            Email:{' '}
            <a href="mailto:info@viridiaanalytics.com" data-id="element-24">
              info@viridiaanalytics.com
            </a>
          </p>
          <p data-id="element-25">Location: Phoenix, AZ — Serving Local Businesses</p>
          <h2 data-id="element-26">Quick Links</h2>
          <ul data-id="element-27">
            <li data-id="element-28">
              <a href="/about" data-id="element-29">About Us</a>
            </li>
            <li data-id="element-30">
              <a href="/case-studies" data-id="element-31">Case Studies</a>
            </li>
            <li data-id="element-32">
              <a href="/pricing" data-id="element-33">Pricing</a>
            </li>
            <li data-id="element-34">
              <a href="/contact" data-id="element-35">Book a Free Strategy Call</a>
            </li>
            <li data-id="element-36">
              <a href="/privacy" data-id="element-37">Privacy Policy</a>
            </li>
            <li data-id="element-38">
              <a href="/terms" data-id="element-39">Terms of Service</a>
            </li>
          </ul>
        </div>
      </noscript>
      <main role="main" className="flex-grow" data-id="element-40">
        <Routes data-id="element-41">
          <Route path="/" element={<HomePage data-id="element-43" />} data-id="element-42" />
          <Route path="/services" element={<Navigate to="/ai-lead-conversion" replace data-id="element-45" />} data-id="element-44" />
          <Route path="/ai-lead-conversion" element={<AutomationsPage data-id="element-47" />} data-id="element-46" />
          <Route path="/automations" element={<Navigate to="/ai-lead-conversion" replace data-id="element-49" />} data-id="element-48" />
          <Route path="/custom-automations" element={<CustomAutomationsPage data-id="element-51" />} data-id="element-50" />
          <Route path="/crm-business-tools" element={<CrmBusinessToolsPage data-id="element-53" />} data-id="element-52" />
          <Route path="/reputation-management" element={<ReputationManagementPage data-id="element-55" />} data-id="element-54" />
          <Route path="/ad-campaigns" element={<AdCampaignsPage data-id="element-57" />} data-id="element-56" />
          <Route path="/web-design-seo" element={<WebDesignSeoPage data-id="element-59" />} data-id="element-58" />
          <Route path="/google-business-profile-setup" element={<GbpSetupPage data-id="element-61" />} data-id="element-60" />
          <Route path="/tools/gmail-signature-generator" element={<GmailSignatureGeneratorPage data-id="element-63" />} data-id="element-62" />
          <Route path="/pricing" element={<PricingPage data-id="element-65" />} data-id="element-64" />
          <Route path="/about" element={<AboutPage data-id="element-67" />} data-id="element-66" />
          <Route path="/case-studies" element={<CaseStudiesPage data-id="element-69" />} data-id="element-68" />
          <Route path="/contact" element={<ContactPage data-id="element-71" />} data-id="element-70" />
          <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-73" />} data-id="element-72" />
          <Route path="/terms" element={<TermsOfServicePage data-id="element-75" />} data-id="element-74" />
        </Routes>
      </main>
      <Footer data-id="element-76" />
    </div>;
}
export function App() {
  useEffect(() => {
    // GHL Chat Widget
    const chatDiv = document.createElement('div');
    chatDiv.setAttribute('data-chat-widget', '');
    chatDiv.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    chatDiv.setAttribute('data-location-id', 'JLycxFbUVQFY3z4zPpCS');
    document.body.appendChild(chatDiv);
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    document.body.appendChild(script);
    return () => {
      if (chatDiv.parentNode) chatDiv.parentNode.removeChild(chatDiv);
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);
  return <BrowserRouter data-id="element-77">
      <ScrollToTop data-id="element-78" />
      <Routes data-id="element-79">
        <Route path="/robots.txt" element={<RobotsTxt data-id="element-81" />} data-id="element-80" />
        <Route path="/sitemap.xml" element={<SitemapXml data-id="element-83" />} data-id="element-82" />
        <Route path="/*" element={<SiteLayout data-id="element-85" />} data-id="element-84" />
      </Routes>
    </BrowserRouter>;
}